import React from 'react';
import OrderTableLabel from '../../../ds/OrderTableLabel/OrderTableLabel';
import { useContent, useLanguages } from '../../../hooks/content';
import { Returntext } from '../../../pages/Landings/common/returnText';
import TipsBox from '../TipsBox/TipsBox';
import './bankPaymentBody.scss';
import { ReactComponent as PcsIcon } from '../../../icons/pcs.svg';
import { ReactComponent as VatIcon } from '../../../icons/vat.svg';
import { ReactComponent as BkpIcon } from '../../../icons/bkp.svg';
import { ReactComponent as EyeIcon } from '../../../icons/eye.svg';
import { ReactComponent as DownloadIcon } from '../../../icons/download2.svg';

import ListItem from '../../../ds/ListItem/ListItem';
import BtnCircular from '../../../ds/BtnCircular/BtnCircular';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import useMobileVhFix from '../../../hooks/height';

const BankPaymentBody = ({ activeOrder }) => {
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();

  // Arrow function for handling click
  const handleNavigate = () => {
    const url = `/invoice/${activeOrder.payments[0]?.id}`;
    window.open(url, '_blank');
  };

  useMobileVhFix();

  return (
    <>
      <TipsBox
        txt={'1'}
        main={Returntext(contentManagementData, 'bp_step_2_step_1_title', lang)}
        sub={Returntext(contentManagementData, 'bp_step_2_step_1_body', lang)}
        icon={<PcsIcon className="icon" />} // Use the SVG component here
      />

      <ListItem
        hasBorder={true}
        hasPadding={true}
        hasIcon={true}
        headline={`${Returntext(contentManagementData, 'invoice', lang)} ${activeOrder?.payments[0]?.invoice_number}`}
        icon={<BkpIcon />}
        buttons={
          <>
            {' '}
            <BtnCircular
              size={'sm'}
              mainColor={'grayBorder'}
              svg={<EyeIcon />}
              disabled={false}
              onClick={handleNavigate}
            />
            {/* <BtnCircular
              size={"sm"}
              mainColor={"grayBorder"}
              svg={<DownloadIcon />}
              disabled={false}
              onClick={handleDownload}
            /> */}
          </>
        }
      />

      <TipsBox
        txt={'2'}
        main={Returntext(contentManagementData, 'bp_step_2_step_2_title', lang)}
        sub={Returntext(contentManagementData, 'bp_step_2_step_2_body', lang)}
        icon={<VatIcon className="icon" />} // Use the SVG component here
      />
    </>
  );
};

export default BankPaymentBody;
